import * as React from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, formatters, defaultProps } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Ratio, Box } from '@src/components';

// typing
interface LocalState extends State {
    count?: any;
}

// style
const style = css`
    .logs {
        ${mixin.row2}
        > article {
            padding: 20px 0;
            text-align: center;
            > .iconBadge {
                ${mixin.iconBadge}
            }
            > h4 {
                font-size: 24px;
            }
        }
        > div {
        }
    }
    .stats {
        > article {
            ${mixin.row}
            margin-bottom: 20px;
            > div {
                &:first-child {
                }
                &:last-child {
                }
                > h4 {
                    font-size: 24px;
                    text-align: center;
                }
            }
        }
    }
`;

const bullet = css`
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 100%;
`;

// component
export class LogsStats extends Proto<Props, LocalState> {

    async componentWillMount() {
        super.componentWillMount();
        const res: any = await this.loadCptData("FleetStats");
        if (res.status === 200) {
            this.setState({
                count: res.data,
            });
        }
    }
    
	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const { data, count } = this.state;
        const { onBattery } = this.props;
        if (!count) return loading;
        const columns = [
            { Header: _('logsstats_col_battery', 'Fleet'), accessor: 'name' },
            { Header: _('logsstats_col_truck_sn', 'Fleet'), accessor: 'truck_sn'},
            { Header: _('logsstats_col_errors', 'Fleet'), accessor: 'count_errors'},
            { Header: _('logsstats_col_warnings', 'Fleet'), accessor: 'count_warnings'},
            { Header: _('logsstats_col_dof', 'Fleet'), accessor: 'count_days'},
        ];
        const colorsErrors = [
            '#daaeae',
            '#d09291',
            '#c46967',
            '#b84c49',
            '#a94542',
            '#993d3b',
            '#853432',
            '#803331',
            '#944f4d',
            '#e0c4c4'
        ];
        const colorsWarning = [
            '#f8b48f',
            '#f79f63',
            '#ed8f42',
            '#da833c',
            '#c57635',
            '#ac672d',
            '#d6803b',
            '#f4b28c',
            '#aa652b'
        ];
        
        const tableProps = {
            ...defaultProps.table({
                showPagination: true,
                onClick: (item) => { if (onBattery) onBattery({id: item.battid}); }
            }),
        }

        const colorCol = { Header: '', id: 'color', accessor: v => (<span className={bullet} style={{backgroundColor: v.color}} />), maxWidth: 40 }
        const columnsErrors = [
            colorCol,
            { Header: _('logsstats_col_errors_detected', 'Fleet'), id: 'message', accessor: v => (_(v.message)) },
            { Header: _('logsstats_col_count', 'Fleet'), accessor: 'count'},
        ];
        const dataErrors = (count && count.errors) ? Object.keys(count.errors).map( (k,i) => ( {
                message: k,
                count: count.errors[k],
                color: colorsErrors[i]
        } )) : null;

        const columnsWarnings = [
            colorCol,
            { Header: _('logsstats_col_warnings_detected', 'Fleet'), id: 'message', accessor: v => (_(v.message)) },
            { Header: _('logsstats_col_count', 'Fleet'), accessor: 'count'},
        ];
        const dataWarnings = (count && count.warnings) ? Object.keys(count.warnings).map( (k,i) => ( {
                message: k,
                count: count.warnings[k],
                color: colorsWarning[i]
        } )) : null;

        const config = {
            "type": "pie",
            "labelsEnabled": false,
            "theme": "light",
            "titleField": "message",
            "valueField": "count",
            "colorField": "color",
            "outlineAlpha": 0.4,
            "depth3D": 15,
            "angle": 30,
        };
      
		return (
            <Box title={_('logsstats_title', 'Fleet')} collapsed={false}>
                <div className={style}>
                    <section className="logs">
                        <article>
                            <span className="iconBadge">
                                <i className="icon-battery" />
                                <strong>{data.length}</strong>
                            </span>
                            <h4>{_('logsstats_bwalarms', 'Fleet')}</h4>
                        </article>
                        <div>
                            <ReactTable
                                {...tableProps}
                                data={data}
                                columns={columns}
                            />
                        </div>
                    </section>
                    <hr />
                    <section className="stats">
                        <article>
                            <div>
                                <Ratio w={16} h={9}>
                                    <AmCharts.React style={{ width: "100%", height: "100%" }} options={{...config, dataProvider: dataErrors}} />
                                </Ratio>
                                <h4>{_('logsstats_col_errors_detected', 'Fleet')}</h4>
                            </div>
                            <div>
                                <ReactTable
                                    {...defaultProps.table()}
                                    data={dataErrors}
                                    columns={columnsErrors}
                                />
                            </div>
                        </article>
                        <article>
                            <div>
                                <Ratio w={16} h={9}>
                                    <AmCharts.React style={{ width: "100%", height: "100%" }} options={{...config, dataProvider: dataWarnings}} />
                                </Ratio>
                                <h4>{_('logsstats_col_warnings_detected', 'Fleet')}</h4>
                            </div>
                            <div>
                                <ReactTable
                                    {...defaultProps.table()}
                                    data={dataWarnings}
                                    columns={columnsWarnings}
                                />
                            </div>
                        </article>
                    </section>
                </div>
            </Box>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Fleet/LogsStats.tsx